
  import { defineComponent, watch } from 'vue';
  import { Icon } from '@/ui/components/icon/Icon';
  import { useDragAndDropUpload } from '@/ui/concerns/useDragAndDropUpload';
  import Loader from '@/_legacy/components/Icons/Loader.vue';

  interface FileUploadProps {
    formats: string[];
    types: string[];
    loading: boolean;
    multiple: boolean;
    disabled?: boolean;
  }

  export default defineComponent<FileUploadProps>({
    components: {
      Icon,
      Loader,
    },
    props: ['formats', 'types', 'multiple', 'loading', 'disabled'],
    emits: ['file-uploaded', 'delete-files'],
    setup(props, context) {
      const {
        onFileChange,
        onDeleteFiles,
        onDrop,
        onBrowse,
        dragover,
        uploadedFiles,
        uploadedFilenames,
        fileInput,
      } = useDragAndDropUpload({
        multiple: props.multiple,
        types: props.types,
      }, context);

      const clearInputOnClick = (ev: MouseEvent) => {
        (ev.target as HTMLInputElement).value = '';
      };

      const onBrowseHandler = () => {
        if (props.disabled) {
          return;
        }
        onBrowse();
      };

      const onDropHandler = (e: DragEvent) => {
        if (props.disabled) {
          return;
        }
        onDrop(e);
      };

      const onDragOverHandler = () => {
        if (!props.disabled) {
          dragover.value = true;
        }
      };

      const onDragEnterHandler = () => {
        if (!props.disabled) {
          dragover.value = true;
        }
      };

      const onDragLeaveHandler = () => {
        if (!props.disabled) {
          dragover.value = false;
        }
      };

      watch(uploadedFiles, () => {
        context.emit('file-uploaded', uploadedFiles.value);
      });

      return {
        onFileChange,
        onDeleteFiles,
        onBrowseHandler,
        onDropHandler,
        onDragOverHandler,
        onDragEnterHandler,
        onDragLeaveHandler,
        dragover,
        uploadedFiles,
        uploadedFilenames,
        fileInput,
        clearInputOnClick,
      };
    },
  });
